export default "__VITE_ASSET__xMU1yYEw__"